
export const FUEL_TYPES = {
    gas: 'All Gas', 
    dual: 'Dual Fuel',
    ceramic: 'Ceramic', 
    induction: 'Induction'
}

export function fromShortcode(code){
    if(!FUEL_TYPES[code]){
        throw new Error('Invalid code ' + code);
    }
    return FUEL_TYPES[code];
}

export function toShortcode(label){
    return Object.entries(label).find( ([_, v]) => v == label)[0]
}


// WEBPACK FOOTER //
// ./src/api/fuel.js